/* import __COLOCATED_TEMPLATE__ from './partner-section.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();